import { render, staticRenderFns } from "./AdyenKlarnaPaymentOption.vue?vue&type=template&id=5b69cc97"
import script from "./AdyenKlarnaPaymentOption.vue?vue&type=script&lang=js"
export * from "./AdyenKlarnaPaymentOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports